document.addEventListener("DOMContentLoaded", (event) => {
  // Init load filtered variant listing
  var variantsSelectorData = variantsFilterFn(variantsData, countryIsoCode, marketISO, blockedCountries);

  // Method to fetch URL information
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  if(urlParams.size > 0) {
    if(urlParams.has('variant')) {
      // Load URL with variant id
      var variantBestOption = getVariantById(variantsSelectorData, urlParams.get('variant'));
      if (!variantBestOption) {
        variantBestOption = variantsFilterFn(variantsSelectorData, countryIsoCode, marketISO, blockedCountries, true);
      }
    } else if(urlParams.has('sku')) {
      // Load URL with variant sku
      var variantBestOption = getVariantBySku(variantsSelectorData, urlParams.get('sku'));
      if (!variantBestOption) {
        variantBestOption = variantsFilterFn(variantsSelectorData, countryIsoCode, marketISO, blockedCountries, true);
      }
    } else {
      // Load default URL
      var variantBestOption = variantsFilterFn(variantsSelectorData, countryIsoCode, marketISO, blockedCountries, true);
    }
  } else {
    // Load default URL
    var variantBestOption = variantsFilterFn(variantsSelectorData, countryIsoCode, marketISO, blockedCountries, true);
  }
//console.log(variantBestOption, "variantBestOption");
  // Render variants selector
  if (variantsSelectorData.length > 0 && variantBestOption != "") {
    // More than one variants
    var variantsSelectorContainer = document.querySelector('#variants-selector-'+section_Id+' .condition-selector-container');
    var variantsSelectorHtml = "";

    variantsSelectorData.forEach(function(variant, index) {
      // Make NEW to display last on the list
      const variantCondition = translations.products.product.condition[variant.condition.toLowerCase()];
      if(variant.condition.replace('_',' ').toLowerCase() === 'new') {
        variantsSelectorHtml += "<div class='radio_button_container new'>";
      } else {
        variantsSelectorHtml += "<div class='radio_button_container'>";
      }
      if (variant.id == variantBestOption.id) {
        variantsSelectorHtml += "<input checked='checked' id='variants-selector-"+section_Id+"-"+index+"' type='radio' name='condition' value='"+variant.id+"' data-collection='"+collectionIds+"' data-note='"+variant.note+"' data-sku='"+variant.sku+"' data-condition='"+variantCondition+"' data-price='"+variant.price+"' data-rrp='"+variant.rrpPrice+"' data-stock='"+variant.inventory_quantity+"'>";
      } else {
        variantsSelectorHtml += "<input id='variants-selector-"+section_Id+"-"+index+"' type='radio' name='condition' value='"+variant.id+"' data-collection='"+collectionIds+"' data-note='"+variant.note+"' data-sku='"+variant.sku+"' data-condition='"+variantCondition+"' data-price='"+variant.price+"' data-rrp='"+variant.rrpPrice+"' data-stock='"+variant.inventory_quantity+"'>";
      }
      variantsSelectorHtml += "<label tabindex='0' class='radio_button_labels pdp-variant' for='variants-selector-"+section_Id+"-"+index+"'>";
      variantsSelectorHtml += "<span>" + variantCondition + "</span>";
      variantsSelectorHtml += "<span class='amount'>"+store_currency_sign + (variant.price / 100).toFixed(2)+"</span>";
      variantsSelectorHtml += "</label>";
      variantsSelectorHtml += "</div>";
    });

    variantsSelectorContainer.innerHTML = variantsSelectorHtml;
    document.dispatchEvent(new CustomEvent("sticky-default-condition", {
      detail: {
        variantId: variantBestOption.id
      }
    }));
    createProductObjectsAndFindPromos();

    const selectorButtons = document.querySelectorAll('.radio_button_labels.pdp-variant');
    for (const checkbox of selectorButtons) {
      // Render variants selector click events
      checkbox.addEventListener('click', function(event) {
        for (const uncheckbox of selectorButtons) {
          document.getElementById(uncheckbox.getAttribute("for")).setAttribute("checked", "");
          document.getElementById(uncheckbox.getAttribute("for")).removeAttribute("checked");
          document.getElementById(uncheckbox.getAttribute("for")).checked = false;
        }
        document.getElementById(this.getAttribute("for")).setAttribute("checked", "checked");
        document.getElementById(this.getAttribute("for")).checked = true;

        // Update price to best option
        updatePrice(document.getElementById(this.getAttribute("for")).getAttribute("data-price"));

        // Update selected option
        updateSelectOption(document.getElementById(this.getAttribute("for")).getAttribute("data-condition"));

        // Update stock total
        updateStock(document.getElementById(this.getAttribute("for")).getAttribute("data-stock"));

        // Update ATB button
        updateAtbButton(getVariantById(variantsSelectorData,document.getElementById(this.getAttribute("for")).value));

        // Update url
        appendQueryStringToCurrentURL(document.getElementById(this.getAttribute("for")).getAttribute("data-sku"));

        // Update wishlist button
        document.dispatchEvent(new CustomEvent("swym:pdp-loaded"));
        document.dispatchEvent(new CustomEvent("ab:sticky-condition", {
          detail: {
            variantId: document.getElementById(this.getAttribute("for")).value
          }
        }));

        document.dispatchEvent(new CustomEvent("update-saving", {
          detail: {
            price: document.getElementById(this.getAttribute("for")).getAttribute("data-price"),
            rrpPrice: document.getElementById(this.getAttribute("for")).getAttribute("data-rrp"),
            isNew: document.getElementById(this.getAttribute("for")).getAttribute("data-condition").toLowerCase() === "new",
          }
        }));

        // Update info in accordion
        if(document.getElementById("info-sku")) {
          document.getElementById("info-sku").innerHTML = document.getElementById(this.getAttribute("for")).getAttribute("data-sku");
        }
        if(document.getElementById("info-condition")) {
          document.getElementById("info-condition").textContent = document.getElementById(this.getAttribute("for")).getAttribute("data-condition");
        }
        if(document.getElementById("info-note")) {
          document.getElementById("info-note").innerHTML = document.getElementById(this.getAttribute("for")).getAttribute("data-note");
        }
      });
    }

    document.querySelector('#variants-selector-'+section_Id).classList.remove("hidden");
    const optionShow = document.querySelectorAll(".display-select-option");
    optionShow.forEach((option) => {
      option.classList.remove("hidden");
    });

    if (variantsSelectorData.length == 1) {
      // Only one variant
      document.querySelector('#variants-selector-'+section_Id).classList.add("hidden");
    }
  } else {
    // No variant
  }

  if (variantBestOption != "") {
    // Update price to best option
    updatePrice(variantBestOption.price);
    document.dispatchEvent(new CustomEvent("update-saving", {
      detail: {
        price: variantBestOption.price,
        rrpPrice: variantBestOption.rrpPrice,
        isNew: variantBestOption.condition.toLowerCase() === "new",
      }
    }));

    // Update selected option
    updateSelectOption(translations.products.product.condition[variantBestOption.condition.toLowerCase()]);


    // Update stock total
    updateStock(variantBestOption.inventory_quantity);

    // Update Promo object
    let promoNode = document.querySelectorAll('input[value="'+variantBestOption.id+'"]');
    if (promoNode[0].hasAttribute("data-promos")) {
      displayPromosForVariant(promoNode[0]);
    }

    if(document.getElementById("info-sku")) {
      document.getElementById("info-sku").innerHTML = variantBestOption.sku;
    }
    if(document.getElementById("info-condition")) {
      document.getElementById("info-condition").textContent = translations.products.product.condition[variantBestOption.condition.toLowerCase()];
    }
    if(document.getElementById("info-note")) {
      document.getElementById("info-note").innerHTML = variantBestOption.note;
    }
  } else {
    // Not showing price
    const priceHide = document.querySelectorAll(".price-display");
    priceHide.forEach((price) => {
      price.classList.add("hidden");
    });

    // Update stock total
    const stockContainer = document.querySelectorAll(".product product-info .stock-counter");
    stockContainer.forEach((stockStatus) => {
      stockStatus.classList.add("hidden");
    });

    // Hide Delivery Block
    const deliveryContainer = document.querySelector(".product product-info .delivery-block");
    if(deliveryContainer) {
      deliveryContainer.classList.add("hidden");
    }
  }

  updateAtbButton(variantBestOption);
});

function updatePrice(variantPrice) {
  const priceShow = document.querySelectorAll(".price-display .price__regular .price-item--regular");
  priceShow.forEach((price) => {
    price.innerHTML = store_currency_sign + (variantPrice / 100).toFixed(2);
  });
}

function updateSelectOption(variantOption) {
  const optionShow = document.querySelectorAll(".display-select-option .option-value");
  optionShow.forEach((option) => {
    option.innerHTML = variantOption;
  });
}

async function updateAtbButton(variant) {
  const form = document.getElementById("product-form-" + section_Id);
  const formID = form.querySelector(".product-variant-id");
  const wishlistButtons = document.querySelectorAll("button.swym-button.swym-add-to-wishlist");
  const button = document.getElementById("ProductSubmitButton-" + section_Id);
  const buttonLabel = button.querySelector("span");
  const atbButtonLabel = translations.products.product.add_to_cart;

  if (variant !== "") {
    if (variant.price > 0 && variant.inventory_quantity > 0) {
      button.disabled = false;
      buttonLabel.innerHTML = atbButtonLabel;
      formID.value = variant.id;

      // Iterate over each wishlist button and update the data-variant-id attribute
      for (const button of wishlistButtons) {
        button.setAttribute('data-variant-id', variant.id);
      }
    } else {
      button.disabled = true;
      buttonLabel.innerHTML = product_sold_out;
    }
  } else {
    button.disabled = true;
    buttonLabel.innerHTML = product_unavailable;
  }
}

function updateStock(variantsStock) {
  let variantsStockDisplay = variantsStock;
  const stockContainerStatus = document.querySelectorAll(".product product-info .stock-counter .stock-display");

  stockContainerStatus.forEach((stockStatus) => {
    const stockContainerText = stockStatus.querySelector("span");
    removeClass(stockStatus, "in-stock");
    removeClass(stockStatus, "low-stock");

    if(variantsStock >= 10) {
      stockStatus.classList.add("in-stock");
      if(variantsStock >= 40) {
        variantsStockDisplay = "40+";
      }

      if(variantsStock >= 30 && variantsStock < 40) {
        variantsStockDisplay = "<40";
      }

      if(variantsStock >= 20 && variantsStock < 30) {
        variantsStockDisplay = "<30";
      }

      if(variantsStock > 10 && variantsStock < 20) {
        variantsStockDisplay = "<20";
      }
    } else {
      if(variantsStock > 0) {
        stockStatus.classList.add("low-stock");
      }
    }

    stockContainerText.innerHTML = variantsStockDisplay + " " + translations.products.product.inventory_in_stock;
  });
}

function hasClass(ele, cls) {
  return ele.className.match(new RegExp('(\\s|^)'+cls+'(\\s|$)'));
}

function removeClass(ele, cls) {
  if (hasClass(ele,cls)) {
    var reg = new RegExp('(\\s|^)'+cls+'(\\s|$)');
    ele.className=ele.className.replace(reg,' ');
  }
}

function appendQueryStringToCurrentURL(sku) {
  const queryString = `sku=${sku}`;
  const url = window.location.href;
  const baseUrl = url.split('?')[0];
  const finalUrl = baseUrl + '?' + queryString;
  window.history.replaceState({}, '', finalUrl);
}


